module.exports = __webpack_public_path__ + "static/logo-white-16cd7bd9cd64ac0b9ae0f0a38ced0d4d.png";